'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { AdminBar } from './AdminBar';
function Footer() {
  const $ = _c(14);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname ? /(^|\/)courses?(\/|$)/.test(pathname) : false;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCoursePage = t0;
  const isBlockPage = pathname ? /\/block\//.test(pathname) : false;
  if (isBlockPage) {
    return null;
  }
  let t1;
  bb0: {
    if (!pathname) {
      t1 = "/";
      break bb0;
    }
    let t2;
    if ($[2] !== searchParams) {
      t2 = searchParams?.toString();
      $[2] = searchParams;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const qs = t2;
    t1 = qs ? `${pathname}?${qs}` : pathname;
  }
  const openHref = t1;
  let t2;
  if ($[4] !== isCoursePage || $[5] !== openHref) {
    t2 = isCoursePage && <a href={openHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-[10px] sm:text-xs text-uzh-blue hover:text-uzh-blue/80 transition-colors whitespace-nowrap" title={"In neuem Tab \xF6ffnen"}><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg><span className="hidden sm:inline">In neuem Tab öffnen</span><span className="sm:hidden">Öffnen</span></a>;
    $[4] = isCoursePage;
    $[5] = openHref;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex items-center gap-3 absolute left-3">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = process.env.NODE_ENV !== "development" && <AdminBar />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex-1 flex flex-col items-center justify-center">{t4}<div className="text-[7px] sm:text-[8px] leading-tight truncate">© {new Date().getFullYear()} Teaching Center, Department of Finance, University of Zurich</div></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <footer className="col-span-2 border-t text-center text-gray-600 h-7 sm:h-8 lg:h-9 flex items-center py-0.5 px-3 gap-3 relative in-iframe:py-0 in-iframe:px-1">{t3}{t5}</footer>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export default Footer;